export const CHANNELS_CATALOG = [
  { key: 'whatsapp', label: 'WhatsApp' },
  { key: 'whatsapp_call', label: 'Llamada WhatsApp' },
  { key: 'phone_call', label: 'Llamada Telefónica' },
  { key: 'instagram', label: 'Instagram' },
  { key: 'web', label: 'Web' },
  { key: 'web_chat', label: 'Chat Web' },
  { key: 'messenger', label: 'Messenger' },
];

export const getDefaultChannels = () => [
  CHANNELS_CATALOG.reduce((acc, c) => ({ ...acc, [c.key]: false }), {}),
];
